var lib_core = require("lib-core");

var LineToolStateMachine = require("./lineToolStateMachine.js");
var AbstractToolController = require("./../../../extensions/abstractToolController.js");

var LineToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        strokeWidth: 2
    });

    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(LineToolController, AbstractToolController);
LineToolController.inject = AbstractToolController.inject;
LineToolController.StateMachineClass = LineToolStateMachine;

module.exports = LineToolController;

LineToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Line',
        title: 'Line',
        style: {
            icon: 'icon-line.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
